import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { color } from '@cowoo/shared';
import { env } from '../env';
import { api } from './api';

/**
 * Stripe.js for the Payment Element (09-web-member § 8.1).
 *
 * The publishable key the server serves wins over the build-time one (04 § 5.4):
 * a rotated key then reaches every open tab without a deploy. Loaded once and
 * shared; `loadStripe` itself caches the script.
 */
let promise: Promise<Stripe | null> | null = null;

export function stripePromise(): Promise<Stripe | null> {
  if (!promise) {
    promise = (async () => {
      let key = env.STRIPE_PUBLISHABLE_KEY ?? '';
      try {
        const { data } = await api.GET('/meta');
        if (data?.stripe.publishableKey) key = data.stripe.publishableKey;
      } catch {
        // `/meta` unreachable: the build-time key is the fallback.
      }
      return key ? loadStripe(key, { locale: 'de' }) : null;
    })();
  }
  return promise;
}

/** § 8.1 rule 3 — the Element in the brand's colours and type. */
export const stripeAppearance = {
  theme: 'stripe' as const,
  variables: {
    colorPrimary: color.teal,
    colorText: color.ink,
    colorDanger: color.dangerText,
    borderRadius: '12px',
    fontFamily: 'Figtree, system-ui, sans-serif',
  },
};

export const stripeFonts = [
  {
    family: 'Figtree',
    src: `url(${window.location.origin}/fonts/figtree-latin-wght-normal.woff2)`,
    weight: '300 900',
  },
];
